import React, { useEffect, useState } from 'react';
import {
  Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField,
} from '@mui/material';

const EMPTY = {
  title: '', description: '', assignee_bot_id: '', due_date: '', priority: 'normal',
};

/** Create or edit a task. `task` null means create. */
export default function TaskDialog({
  open, task, bots, saving, error, onClose, onSave,
}) {
  const [form, setForm] = useState(EMPTY);
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (!open) return;
    setLocalError('');
    setForm(task ? {
      title: task.title,
      description: task.description || '',
      assignee_bot_id: task.assignee?.id || '',
      due_date: task.due_date || '',
      priority: task.priority,
    } : EMPTY);
  }, [open, task]);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (form.title.trim().length < 2) { setLocalError('Give the task a title (at least 2 characters).'); return; }
    setLocalError('');
    onSave({
      title: form.title.trim(),
      description: form.description.trim(),
      assignee_bot_id: form.assignee_bot_id || null,
      due_date: form.due_date || null,
      priority: form.priority,
    });
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth component="form" onSubmit={submit}>
      <DialogTitle>{task ? 'Edit task' : 'New task'}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {(localError || error) && <Alert severity="error">{localError || error}</Alert>}
          <TextField label="Title" value={form.title} onChange={set('title')} fullWidth autoFocus inputProps={{ maxLength: 200 }} />
          <TextField label="Details (optional)" value={form.description} onChange={set('description')} multiline minRows={3} fullWidth inputProps={{ maxLength: 2000 }} />
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField select label="Who does it" value={form.assignee_bot_id} onChange={set('assignee_bot_id')} fullWidth>
              <MenuItem value="">Nobody yet</MenuItem>
              {bots.map((b) => <MenuItem key={b.id} value={b.id}>{`${b.name} (${b.role})`}</MenuItem>)}
            </TextField>
            <TextField select label="Priority" value={form.priority} onChange={set('priority')} sx={{ minWidth: 140 }}>
              <MenuItem value="low">Low</MenuItem>
              <MenuItem value="normal">Normal</MenuItem>
              <MenuItem value="high">High</MenuItem>
            </TextField>
          </Stack>
          <TextField label="Due date (optional)" type="date" value={form.due_date} onChange={set('due_date')} InputLabelProps={{ shrink: true }} />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button type="submit" variant="contained" disabled={saving}>{task ? 'Save' : 'Add task'}</Button>
      </DialogActions>
    </Dialog>
  );
}
